/* template */
<template minapp="mpx" xlang="wxml"><div class="es-content__tip"><mpx-view @tap="handleRead" class="es-content__tip-radio"><checkbox-icon :size="(14)" :checked="(innerValue)" class="es-content__check-box" :custom-class='["es-content__check-box"].join(" ")'/><span>阅读并同意以下内容</span></mpx-view><div class="es-content__tip-text">{{tipText}}</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mbb5fc7e6"}'>
  +b('content')
    +e('tip')
      margin 0 12px 40px 12px
      background-color transparent
    +e('tip-radio')
      color #666666
      font-size 12px
      margin-bottom 4px
      display flex
      align-items center
    +e('check-box')
      margin-right 3px !important
      vertical-align middle !important
    +e('tip-text')
      color #999999
      font-size 12px
      text-align justify
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mbb5fc7e6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./tip-text.mpx.js?isComponent&outputPath=components%2Ftip-textbb5fc7e6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./tip-text.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ftip-textbb5fc7e6%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mbb5fc7e6"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/tip-textbb5fc7e6/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'checkbox-icon':getComponent(require("../../checkbox-icon/index.mpx?isComponent&outputPath=components%2Findex214602b1%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'es-field':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/field/index.mpx?isComponent&outputPath=components%2Findex69975464%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
